// @core/api/endpoints/team/get_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RoleDelegationResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get role delegation
 * Retrieves role delegation by the specified identifier.
 */
export async function GetRoleDelegation(
  team_id: string,
  delegation_id: string,
  options?: RequestOptions
): Promise<RoleDelegationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations/:delegation_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':delegation_id', encodeURIComponent(delegation_id));
  const requestOptions = options;
  return client.get<RoleDelegationResponse>(requestPath, { ...requestOptions });
}
